var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-container"},[_vm._v(_vm._s(_vm.title)+" "),_c('input',{staticClass:"widget_checkbox",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_c('span',{staticClass:"checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }